
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SystemMainframeEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const spacing = (400 + layerIndex * 200) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const drawMainframe = (x: number, y: number, s: number) => {
             ctx.save();
             ctx.translate(x, y);
             ctx.globalAlpha *= 0.2;
             
             // Large chip body
             ctx.strokeRect(-s/2, -s/2, s, s);
             ctx.strokeRect(-s/2.5, -s/2.5, s/1.25, s/1.25);
             
             // Connector pins
             for (let i = -5; i <= 5; i++) {
                 const p = (i / 5) * (s/2);
                 ctx.beginPath();
                 ctx.moveTo(p, -s/2); ctx.lineTo(p, -s/2 - 20 * scale);
                 ctx.moveTo(p, s/2); ctx.lineTo(p, s/2 + 20 * scale);
                 ctx.moveTo(-s/2, p); ctx.lineTo(-s/2 - 20 * scale, p);
                 ctx.moveTo(s/2, p); ctx.lineTo(s/2 + 20 * scale, p);
                 ctx.stroke();
             }
             
             // Pulsing core
             const pulse = (Math.sin(curTime * 2) + 1) * 0.5;
             ctx.fillStyle = pc.color;
             ctx.globalAlpha = pulse * 0.3;
             ctx.fillRect(-s/6, -s/6, s/3, s/3);
             ctx.restore();
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    drawMainframe(x, y, spacing * 0.8 * scale);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
